export default __webpack_public_path__ + "2fd55066fd00df5540c2e7165145f7b5.svg";